import LngDetector from "i18next-browser-languagedetector";
import i18next from "i18next";
import de from "../i18n/de.json";
import en from "../i18n/en.json";
import es from "../i18n/es.json";
import fr from "../i18n/fr.json";
import it from "../i18n/it.json";
import ja from "../i18n/ja.json";
import ko from "../i18n/ko.json";
import nl from "../i18n/nl.json";
import pl from "../i18n/pl.json";
import pt from "../i18n/pt.json";
import ru from "../i18n/ru.json";
import tr from "../i18n/tr.json";
import zh from "../i18n/zh.json";
import bg from "../i18n/bg.json";
import cs from "../i18n/cs.json";
import da from "../i18n/da.json";
import el from "../i18n/el.json";
import fi from "../i18n/fi.json";
import hu from "../i18n/hu.json";
import ro from "../i18n/ro.json";
import sv from "../i18n/sv.json";
import th from "../i18n/th.json";
import za from "../i18n/za.json";
import br from "../i18n/br.json";

i18next.use(LngDetector).init(
    {
        debug: process.env.DEBUG === "true",
        fallbackLng: "en",
        resources: { de, en, es, fr, it, ja, ko, nl, pl, pt, ru, tr, zh, bg, cs, da, el, hu, ro, sv, th, za, fi, br },
        detection: {
            order: ["navigator"],
        },
    },
    err => {
        if (err) {
            console.log("There was an error with your translation:", err);
        }
    }
);

export default i18next;
